(function(angular){
	'use strict';
	
	angular
		.module('ipoModule', [
			'affixRevealModule',
			'confirmationModalModule',
			'coreModule',
			'formValidationModule',
			'highPerformanceHighPotentialChartModule',
			'ipoSharePriceChartModule'
		])
		.value('globalConfig', globalConfig);

})(window.angular);